import {
  Button,
  Card,
  Divider,
  Image,
  Modal,
  Progress,
  Typography,
} from 'antd';
import { useContext, useState } from 'react';
import others from '../../../Assets/others.svg';
import { logoBaseURL } from '../../../Utils/constants';
import { categoriesMapping, categoryLogos } from '../../../Utils/utils';
import Budget from '../../Budget';
import './index.css';
import { DashboardContext } from '..';
import getNudges from '../../../Utils/nudgeUtils';
import Nudges from '../Nudges';

const BudgetHomeScreen = () => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const { listOfItemsBudget, setListOfItemsBudget }: any =
    useContext(DashboardContext);

  return (
    <>
      <Modal
        centered={true}
        footer={null}
        open={isModalOpen}
        closable={true}
        onCancel={() => {
          setIsModalOpen(false);
        }}
      >
        <Budget
          setIsModalOpen={setIsModalOpen}
          addBudget={(e) => {
            setListOfItemsBudget([...listOfItemsBudget, e]);
          }}
        />
      </Modal>

      <Card>
        {listOfItemsBudget.map((item: any, index: number) => {
          return (
            <>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <div
                  style={{
                    fontWeight: 500,
                    display: 'flex',
                    gap: 8,
                    alignItems: 'center',
                  }}
                >
                  <Image
                    style={{ width: 20 }}
                    preview={false}
                    src={logoBaseURL + categoryLogos[item.name] + '.jpg'}
                    rootClassName={'icon'}
                    fallback={others}
                  />
                  <div>
                    {categoriesMapping[item.name]}
                    <Progress
                      percent={(item.spend / item.budget) * 100}
                      size="small"
                      status="active"
                    />
                  </div>
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-end',
                  }}
                >
                  <div style={{ color: 'rgba(0, 0, 0, 0.6)' }}>
                    Spending:{' '}
                    <Typography.Text
                      style={{
                        fontWeight: 500,
                        color: `${item.spend >= item.budget ? 'red' : 'green'}`,
                      }}
                    >
                      ₹{item.spend.toLocaleString('en-IN')}
                    </Typography.Text>
                  </div>
                  <div style={{ color: 'rgba(0, 0, 0, 0.6)' }}>
                    Budget:{' '}
                    <Typography.Text
                      style={{ fontWeight: 500, color: 'rgba(0, 0, 0, 0.7)' }}
                    >
                      ₹{item.budget.toLocaleString('en-IN')}
                    </Typography.Text>
                  </div>
                </div>
              </div>
              {index === listOfItemsBudget.length - 1 ? (
                <></>
              ) : (
                <Divider style={{ margin: '12px 0px' }} />
              )}
            </>
          );
        })}

        <Button
          onClick={() => {
            setIsModalOpen(true);
          }}
          className="budgetButton"
          style={{
            marginLeft: 'auto',
            marginRight: 'auto',
            marginTop: 16,
            display: 'flex',
          }}
        >
          Add Budget
        </Button>
      </Card>
      <Nudges nudgeList={getNudges('budget')} />
    </>
  );
};

export default BudgetHomeScreen;
